import React from 'react'
import { useLocation } from 'react-router-dom'
import { useUserAuthentification, useUserQuery } from '../../../../api/user/hooks'
import { AppAuthProviderProps, useAppAuthProviderProps } from '../types'

const useAppAuthProvider = (props: useAppAuthProviderProps): AppAuthProviderProps => {
    const [synonym, setSynonym] = React.useState<string>()
    const [token, setToken] = React.useState<string>()
    const { data: user } = useUserQuery(token)
    const authMutation = useUserAuthentification()

    const { search } = useLocation()
    const queryString = new URLSearchParams(search)
    const guidQ = queryString.get('guid')
    const hashQ = queryString.get('hash')
    const synonymQ = queryString.get('synonym')

    // init - set synonym/token from query/localStorage
    React.useEffect(() => {
        if (synonymQ) {
            localStorage.removeItem('synonym')
            localStorage.removeItem('token')
            setSynonym(synonymQ)
            setToken(undefined)
        } else {
            const synonymLS = localStorage.getItem('synonym')
            const tokenLS = localStorage.getItem('token')
            if (synonymLS && tokenLS) {
                setSynonym(synonymLS)
                setToken(tokenLS)
            } else {
                // TODO: Switch comment if re-renders occur on dev
                // console.log('redirecting to ', process.env.REACT_APP_LOGIN_REDIRECT)
                if (process.env.REACT_APP_LOGIN_REDIRECT) window.location.replace(process.env.REACT_APP_LOGIN_REDIRECT)
            }
        }
    }, [synonymQ])

    // store to localStorage
    React.useEffect(() => {
        if (synonym) {
            //console.log('setting synonym to LS')
            localStorage.setItem('synonym', synonym)
        }
        if (token) {
            //console.log('setting token to LS', token)
            localStorage.setItem('token', token)
        }
    }, [synonym, token])

    // authorize
    React.useEffect(() => {
        if (guidQ && hashQ && synonym && token === undefined && authMutation.status === 'idle') {
            authMutation.mutate({ apiCode: guidQ, hash: hashQ })
        }
    }, [authMutation, guidQ, hashQ, synonym, token])

    // set token from mutation
    React.useEffect(() => {
        if (authMutation.isSuccess && authMutation.data) {
            //console.log('auth success, setting token')
            setToken(authMutation.data.tokenCode)
        }
    }, [authMutation.data, authMutation.isSuccess])

    const isAuthenticated =
        synonym !== undefined &&
        token !== undefined &&
        synonym === localStorage.getItem('synonym') &&
        token === localStorage.getItem('token')
    //console.log('isAuthenticated', isAuthenticated)
    // is authenticated, if there is synonom and token, and also present in localStorage
    return {
        contextValue: {
            isAuthenticated,
            user,
            token: token || undefined,
            synonym,
        },
    }
}

export default useAppAuthProvider
